import React, { Component, useMemo } from 'react';
import { bool, func, object, string } from 'prop-types';
import { Form as FinalForm, Field } from 'react-final-form';
import classNames from 'classnames';

import { intlShape, injectIntl } from '../../../../util/reactIntl';
import { isMainSearchTypeKeywords } from '../../../../util/search';
import { useConfiguration } from '../../../../context/configurationContext';

import { Form, LocationAutocompleteInput } from '../../../../components';

import IconSearchDesktop from './IconSearchDesktop';
import css from './TopbarSearchForm.module.css';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { parse } from '../../../../util/urlHelpers';
import { tireDimensionSuggestions } from '../../../../util/tireDimensionSuggestions';
import { falgarSuggestions } from '../../../../util/falgarSuggestions';
import SearchIcon from '@mui/icons-material/Search';


const identity = v => v;

const KeywordSearchField = props => {
  const { keywordSearchWrapperClasses, iconClass, intl, isMobile, inputRef, form, isSearchPage } = props;
  const config = useConfiguration();
  // console.log('config', config)
  const listingCategories = config?.categoryConfiguration?.categories || [];

  // Flatten categories and subcategories to display
  const categorySuggestions = useMemo(() => {
    return listingCategories.flatMap(cat => {
      const level1 = cat?.id || '';
      const level2List = cat?.subcategories || [];

      const parent = {
        label: cat?.name,
        level1,
        level2: '',
        type: 'category',
      };

      const children = level2List.map(sub => ({
        label: `${cat?.name} ${sub.name}`,
        level1,
        level2: sub.id,
        type: 'subcategory',
      }));

      return [parent, ...children];
    });
  }, [listingCategories]);

  const allSuggestions = useMemo(() => {
    return [...categorySuggestions, ...tireDimensionSuggestions, ...falgarSuggestions];
  }, [categorySuggestions]);

  return (
    <div className={keywordSearchWrapperClasses}>
      {isSearchPage ? <div className={css.muiSearchIcon}>
        <SearchIcon fontSize="large" />
      </div> : <button className={css.searchSubmit}>
        <div className={iconClass}>
          <IconSearchDesktop />
        </div>
      </button>}

      <Field
        name="keywords"
        render={({ input }) => (
          <Autocomplete
            freeSolo
            fullWidth
            className={css.autocompleteInputRoot}
            sx={{ height: '100%' }}
            inputValue={input.value || ""}
            // options={categorySuggestions}
            options={allSuggestions}
            filterOptions={(options, params) => {
              const rawInput = params.inputValue ? params.inputValue.trim() : '';
              if (rawInput.length === 0) return [];

              const typed = rawInput.toLowerCase();

              const keywordOption = [
                {
                  label: rawInput,
                  type: 'keyword',
                  value: rawInput,
                },
              ];

              const filtered = [];
              for (let i = 0; i < options.length; i++) {
                const option = options[i];
                if (!option.label || option.label.trim() === '') continue;

                let matches = false;
                const lowerLabel = option.label.toLowerCase();

                if (option.type === 'category' || option.type === 'subcategory') {
                  matches = lowerLabel.includes(typed);
                } else if (option.type === 'dimension') {
                  matches =
                    lowerLabel.includes(typed) ||
                    `${option.width} ${option.profile} ${option.diameter}`.includes(typed);
                } else if (
                  option.type === 'rim-boltpattern' ||
                  option.type === 'rim-diameter' ||
                  option.type === 'rim-brand'
                ) {
                  matches = lowerLabel.includes(typed);
                }

                if (matches) {
                  filtered.push(option);
                  if (filtered.length >= 30) break;
                }
              }

              return [...keywordOption, ...filtered];
            }}
            getOptionLabel={(option) => {
              if (typeof option === "string") return option;
              return option?.label || "";
            }}
            renderOption={(props, option) => (
              <li {...props}>
                <span
                  style={{
                    color: option.type === 'keyword' ? 'black' : 'black',
                    fontWeight: option.type === 'keyword' ? 'normal' : 'normal',
                    display: 'inline',
                  }}
                >
                  {option.label}
                </span>

                {option.type === 'keyword' && (
                  <span style={{ color: '#a0a0a0', fontWeight: 'lighter', marginLeft: '5px' }}> Textsök</span>
                )}

                {option.type === 'category' && (
                  <span style={{ color: '#a0a0a0', fontWeight: 'lighter', marginLeft: '5px' }}> Bilmärke</span>
                )}

                {option.type === 'subcategory' && (
                  <span style={{ color: '#a0a0a0', fontWeight: 'lighter', marginLeft: '5px' }}> Bilmodell</span>
                )}
                {option.type === 'dimension' && (
                  <span style={{ color: '#a0a0a0', fontWeight: 'lighter', marginLeft: 5 }}>
                    Dimension
                  </span>
                )}

                {option.type === 'rim-boltpattern' && (
                  <span style={{ color: '#a0a0a0', fontWeight: 'lighter', marginLeft: '5px' }}>Fälgar</span>
                )}
                {option.type === 'rim-diameter' && (
                  <span style={{ color: '#a0a0a0', fontWeight: 'lighter', marginLeft: '5px' }}>Fälgar</span>
                )}
                {option.type === 'rim-brand' && (
                  <span style={{ color: '#a0a0a0', fontWeight: 'lighter', marginLeft: '5px' }}>Fälgar</span>
                )}

              </li>
            )}
            onInputChange={(e, value) => {
              input.onChange(value);
              if (value === "") {
                form.change("keywords", undefined);
                form.change("categoryLevel1", "");
                form.change("categoryLevel2", "");
                form.change("tireWidthFront", "");
                form.change("profileFront", "");
                form.change("diameter", "");
                form.change("numberOfBolts", "");
                form.change("boltCircle", "");
                form.change("adType", "");

                setTimeout(() => form.submit(), 50);
              }
            }}
            onChange={(e, option) => {
              if (!option) return;

              if (option.type === "keyword") {
                form.change("keywords", option.value);
                form.change("categoryLevel1", "");
                form.change("categoryLevel2", "");
                form.change("tireWidthFront", "");
                form.change("profileFront", "");
                form.change("diameter", "");
                form.change("numberOfBolts", "");
                form.change("boltCircle", "");
                form.change("adType", "");
                setTimeout(() => form.submit(), 50);
                return;
              }

              if (option.type === "category" || option.type === "subcategory") {
                form.change("keywords", "");
                form.change("categoryLevel1", option.level1);
                form.change("categoryLevel2", option.level2);
                form.change("numberOfBolts", "");
                form.change("boltCircle", "");
                form.change("adType", "");
                setTimeout(() => form.submit(), 50);
                return;
              }

              if (option.type === "dimension") {
                form.change("keywords", "");
                form.change("categoryLevel1", "");
                form.change("categoryLevel2", "");
                form.change("tireWidthFront", option.width);
                form.change("profileFront", option.profile);
                form.change("diameter", option.diameter);
                form.change("numberOfBolts", "");
                form.change("boltCircle", "");
                form.change("adType", "");
                setTimeout(() => form.submit(), 50);
                return;
              }

              if (option.type === "rim-boltpattern") {
                form.change("keywords", "");
                form.change("categoryLevel1", "");
                form.change("categoryLevel2", "");
                form.change("tireWidthFront", "");
                form.change("profileFront", "");
                form.change("diameter", "");
                form.change("numberOfBolts", option.numberOfBolts);
                form.change("boltCircle", option.boltCircle);
                form.change("adType", option.adType);
                setTimeout(() => form.submit(), 50);
                return;
              }

              if (option.type === "rim-diameter") {
                form.change("keywords", "");
                form.change("categoryLevel1", "");
                form.change("categoryLevel2", "");
                form.change("tireWidthFront", "");
                form.change("profileFront", "");
                form.change("numberOfBolts", "");
                form.change("boltCircle", "");
                form.change("diameter", option.diameter);
                form.change("adType", option.adType);
                setTimeout(() => form.submit(), 50);
                return;
              }

              if (option.type === "rim-brand") {
                form.change("keywords", "");
                form.change("categoryLevel1", option.categoryLevel1);
                form.change("categoryLevel2", "");
                form.change("tireWidthFront", "");
                form.change("profileFront", "");
                form.change("diameter", "");
                form.change("numberOfBolts", "");
                form.change("boltCircle", "");
                form.change("adType", option.adType);
                setTimeout(() => form.submit(), 50);
                return;
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                placeholder={intl.formatMessage({
                  id: 'TopbarSearchForm.placeholder',
                })}
                inputRef={inputRef}
                className={css.autocompleteTextField}
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                  className: css.autocompleteInputRoot,
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      border: 'none !important',
                    },
                    '&:hover fieldset': {
                      border: 'none !important',
                    },
                    '&.Mui-focused fieldset': {
                      border: 'none !important',
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    outline: 'none !important',
                    border: 'none !important',
                    boxShadow: 'none !important',
                  },
                  '& .MuiAutocomplete-endAdornment': {
                    right: isSearchPage ? '36px' : '0px',
                  },

                }}
                inputProps={{
                  ...params.inputProps,
                  className: css.autocompleteInput,
                }}
              />
            )}
          />
        )}
      />
    </div>
  );
};

const LocationSearchField = props => {
  const { desktopInputRootClass, intl, isMobile, inputRef, onLocationChange } = props;
  return (
    <Field
      name="location"
      format={identity}
      render={({ input, meta }) => {
        const { onChange, ...restInput } = input;

        // Merge the standard onChange function with custom behaviur. A better solution would
        // be to use the FormSpy component from Final Form and pass this.onChange to the
        // onChange prop but that breaks due to insufficient subscription handling.
        // See: https://github.com/final-form/react-final-form/issues/159
        const searchOnChange = value => {
          onChange(value);
          onLocationChange(value);
        };

        return (
          <LocationAutocompleteInput
            className={isMobile ? css.mobileInputRoot : desktopInputRootClass}
            iconClassName={isMobile ? css.mobileIcon : css.desktopIcon}
            inputClassName={isMobile ? css.mobileInput : css.desktopInput}
            predictionsClassName={isMobile ? css.mobilePredictions : css.desktopPredictions}
            predictionsAttributionClassName={isMobile ? css.mobilePredictionsAttribution : null}
            placeholder={intl.formatMessage({ id: 'TopbarSearchForm.placeholder' })}
            closeOnBlur={!isMobile}
            inputRef={inputRef}
            input={{ ...restInput, onChange: searchOnChange }}
            meta={meta}
          />
        );
      }}
    />
  );
};

/* The pages whose main input is this search: /annonser and its make/model
 * pages. The seller tools that also live under /annonser/ are forms; moving
 * focus to the search box there takes it away from the field being typed in
 * (found on the storage route's per-wheel table, P25009-485). */
const SELLER_TOOL_PATHS = [
  '/annonser/skapa',
  '/annonser/bulk-upload',
  '/annonser/bygg-paket',
  '/annonser/hjulprogram',
];
const isSearchPagePath = pathname =>
  !!pathname &&
  pathname.includes('/annonser') &&
  !SELLER_TOOL_PATHS.some(tool => pathname.startsWith(tool));

class TopbarSearchFormComponent extends Component {
  timeoutId = null;
  constructor(props) {
    super(props);
    // onChange is used for location search
    this.onChange = this.onChange.bind(this);
    // onSubmit is used for keywords search
    this.onSubmit = this.onSubmit.bind(this);

    // Callback ref
    this.searchInput = null;
    this.setSearchInputRef = element => {
      // this.setSearchInput = element;
      this.searchInput = element;
    };
  }

  componentDidMount() {
    const isSearchPage = typeof window !== 'undefined' && isSearchPagePath(window.location.pathname);
    if (isSearchPage && this.searchInput) {
      setTimeout(() => this.searchInput.focus(), 100);
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.location || !this.props.location) return;
    const prevSearch = prevProps.location.search;
    const currentSearch = this.props.location.search;

    if (prevSearch !== currentSearch) {
      const query = parse(currentSearch);

      const isEmpty =
        Object.keys(query).length === 0 ||
        (Object.keys(query).length === 1 && query.page);

      if (isEmpty && this.formInstance) {
        this.formInstance.change("keywords", "");
        this.formInstance.change("categoryLevel1", "");
        this.formInstance.change("categoryLevel2", "");
        this.formInstance.change("tireWidthFront", "");
        this.formInstance.change("profileFront", "");
        this.formInstance.change("diameter", "");
        this.formInstance.change("numberOfBolts", "");
        this.formInstance.change("boltCircle", "");
        this.formInstance.change("adType", "");
      }
    }

    /* Only after a navigation. The topbar also re-renders when it compresses
     * on scroll, and refocusing then pulled focus out of whatever the visitor
     * had just clicked into. */
    const locationChanged =
      prevSearch !== currentSearch || prevProps.location.pathname !== this.props.location.pathname;
    const isSearchPage = typeof window !== 'undefined' && isSearchPagePath(window.location.pathname);
    if (locationChanged && isSearchPage && this.searchInput) {
      setTimeout(() => this.searchInput.focus(), 100);
    }
  }

  onChange(location) {
    console.log(location);
    const { appConfig, onSubmit } = this.props;
    if (!isMainSearchTypeKeywords(appConfig) && location.selectedPlace) {
      // Note that we use `onSubmit` instead of the conventional
      // `handleSubmit` prop for submitting. We want to autosubmit
      // when a place is selected, and don't require any extra
      // validations for the form.
      onSubmit({ location });
      // blur search input to hide software keyboard
      this.searchInput?.blur();
    }
  }

  // onSubmit(values) {
  //   const { appConfig, onSubmit } = this.props;
  //   if (isMainSearchTypeKeywords(appConfig)) {
  //     onSubmit({ keywords: values.keywords });
  //     // blur search input to hide software keyboard
  //     this.searchInput?.blur();
  //   }
  // }

  onSubmit(values) {
    const { appConfig, onSubmit } = this.props;

    if (values.numberOfBolts && values.boltCircle) {
      onSubmit({
        numberOfBolts: values.numberOfBolts,
        boltCircle: values.boltCircle,
        adType: values.adType || 'rim',
      });
      this.searchInput?.blur();
      return;
    }

    if (values.diameter && values.adType === 'rim') {
      onSubmit({
        diameter: values.diameter,
        adType: values.adType,
      });
      this.searchInput?.blur();
      return;
    }

    if (values.categoryLevel1 && values.adType === 'rim') {
      onSubmit({
        categoryLevel1: values.categoryLevel1,
        categoryLevel2: values.categoryLevel2 || '',
        adType: values.adType,
      });
      this.searchInput?.blur();
      return;
    }

    if (values.categoryLevel1) {
      onSubmit({
        categoryLevel1: values.categoryLevel1,
        categoryLevel2: values.categoryLevel2 || ""
      });
      this.searchInput?.blur();
      return;
    }

    if (values.tireWidthFront && values.profileFront && values.diameter) {
      onSubmit({
        tireWidthFront: values.tireWidthFront,
        profileFront: values.profileFront,
        diameter: values.diameter,
      });
      this.searchInput?.blur();
      return;
    }

    if (isMainSearchTypeKeywords(appConfig)) {
      onSubmit({ keywords: values.keywords });
    }

    this.searchInput?.blur();
  }




  render() {
    const { onSubmit, appConfig, ...restOfProps } = this.props;
    const isKeywordsSearch = isMainSearchTypeKeywords(appConfig);
    const submit = isKeywordsSearch ? this.onSubmit : onSubmit;
    return (
      <FinalForm
        {...restOfProps}
        onSubmit={submit}
        render={formRenderProps => {
          this.formInstance = formRenderProps.form;
          const {
            rootClassName,
            className,
            desktopInputRoot,
            intl,
            isMobile,
            handleSubmit,
          } = formRenderProps;
          const classes = classNames(rootClassName, className);
          const desktopInputRootClass = desktopInputRoot || css.desktopInputRoot;
          const isSearchPage = typeof window !== 'undefined' && window.location.pathname.includes('/annonser');
          console.log('isSearchPage', isSearchPage)

          // Location search: allow form submit only when the place has changed
          const preventFormSubmit = e => e.preventDefault();
          const submitFormFn = isKeywordsSearch ? handleSubmit : preventFormSubmit;

          const keywordSearchWrapperClasses = classNames(
            css.keywordSearchWrapper,
            isMobile ? css.mobileInputRoot : desktopInputRootClass,
            {
              [css.searchPageBorder]: isSearchPage,
            }
          );

          return (
            <Form className={classes} onSubmit={submitFormFn} enforcePagePreloadFor="SearchPage">
              <Field name="categoryLevel1" component="input" type="hidden" />
              <Field name="categoryLevel2" component="input" type="hidden" />
              <Field name="tireWidthFront" component="input" type="hidden" />
              <Field name="profileFront" component="input" type="hidden" />
              <Field name="diameter" component="input" type="hidden" />
              <Field name="numberOfBolts" component="input" type="hidden" />
              <Field name="boltCircle" component="input" type="hidden" />
              <Field name="adType" component="input" type="hidden" />
              {isKeywordsSearch ? (
                <KeywordSearchField
                  keywordSearchWrapperClasses={keywordSearchWrapperClasses}
                  iconClass={classNames(isMobile ? css.mobileIcon : css.desktopIcon || css.icon)}
                  intl={intl}
                  isMobile={isMobile}
                  inputRef={this.setSearchInputRef}
                  form={formRenderProps.form}
                  isSearchPage={isSearchPage}
                />
              ) : (
                <LocationSearchField
                  desktopInputRootClass={desktopInputRootClass}
                  intl={intl}
                  isMobile={isMobile}
                  inputRef={this.setSearchInputRef}
                  onLocationChange={this.onChange}
                />
              )}
            </Form>
          );
        }}
      />
    );
  }
}

TopbarSearchFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  desktopInputRoot: null,
  isMobile: false,
};

TopbarSearchFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  desktopInputRoot: string,
  onSubmit: func.isRequired,
  isMobile: bool,
  appConfig: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const TopbarSearchForm = withRouter(injectIntl(TopbarSearchFormComponent));

export default TopbarSearchForm;
